import script from "./CourseForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseForm.vue?vue&type=script&setup=true&lang=ts"

import "./CourseForm.vue?vue&type=style&index=0&id=6ec583b2&lang=css"

const __exports__ = script;

export default __exports__